import {
  AdminAppealUpdateStatusRequest,
  AdminAppealUpdateSumRequest,
} from "@features/admin/appeals/api";
import * as yup from "yup";

export const sumSchema: yup.ObjectSchema<AdminAppealUpdateSumRequest> = yup
  .object()
  .shape({
    new_sum: yup.number().required(),
    reason: yup.string().required().trim(),
  });

export const statusSchema: yup.ObjectSchema<AdminAppealUpdateStatusRequest> =
  yup.object().shape({
    approve: yup.boolean().required(),
    actual_received_amount: yup.number(),
  });
